var _rect, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreToggleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#899AA3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 7.5,
    r: 1.5,
    fill: "#DBDFE1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 1.5,
    fill: "#DBDFE1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 7.5,
    r: 1.5,
    fill: "#DBDFE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreToggleActive);
export default __webpack_public_path__ + "static/media/more_toggle_active.cad0ef95f90c441340464eed3f3eaa54.svg";
export { ForwardRef as ReactComponent };